export default __webpack_public_path__ + "static/media/Profile.b4a4e7d1.svg";